const EMAIL_LINK_PARAM = "bfe";
const AUTH_PATHS = new Set(["/login", "/signup"]);

/** Resolve `?back=` deeplink targets used by login/signup flows. */
export function resolveAuthBackPath(back: string | null | undefined): string | null {
  if (!back || back.trim() === "") return null;
  const trimmed = back.trim();
  if (trimmed === "games" || trimmed === "/games") return "/";
  return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
}

/**
 * Current page as a post-auth `back=` target.
 * Returns null on login/signup so we don't bounce users in a loop.
 */
export function locationAuthBackPath(pathname: string, search = ""): string | null {
  if (AUTH_PATHS.has(pathname)) return null;
  return `${pathname}${search || ""}` || "/";
}

/** Build `/login` or `/signup` with optional return path and guest-spin params. */
export function buildAuthHref(
  mode: "login" | "signup",
  options?: {
    back?: string | null;
    gamesession?: string | null;
    game?: string | null;
    coins?: string | null;
    rubies?: string | null;
  },
): string {
  const params = new URLSearchParams();
  const o = options || {};
  if (o.gamesession) params.set("gamesession", o.gamesession);
  if (o.game) params.set("game", o.game);
  if (o.coins) params.set("coins", o.coins);
  if (o.rubies) params.set("rubies", o.rubies);
  if (o.back) params.set("back", o.back);
  const qs = params.toString();
  return qs ? `/${mode}?${qs}` : `/${mode}`;
}

/** Where to send an already-logged-in user who opened /login or /signup. */
export function authPageRedirectTarget(search: string): string {
  const params = new URLSearchParams(search);
  const back = resolveAuthBackPath(params.get("back"));
  if (back) return back;
  if (params.get(EMAIL_LINK_PARAM) === "1") return "/?bfe=1";
  return "/";
}
